export default "__VITE_ASSET__D9V7dskt__"